import gql from 'graphql-tag'
import getOperationNameFromQuery from '../utils/get-operation-name-from-query'

const userPermissionGrants = gql`
  query UserPermissionGrants(
		$permissions: [Permission!]
		$resourceTypes: [ResourceType!]
		$objectIds: [ID!]
	) {
    userPermissionGrants( permissions: $permissions, resourceTypes: $resourceTypes, objectIds: $objectIds ) {
      permission
      objectIds
    }
  }
`

export const userPermissionGrantsQueryName = getOperationNameFromQuery( userPermissionGrants )
export default userPermissionGrants
